<template>
  <div class="user-manage-constructor main-body">
    <div class="button-search-body">
      <div class="search-body">
        <div class="button-body">
          <ButtonList 
            :list="buttonList"
            :target="buttonTarget"
          />
        </div>
        <el-input 
          v-model="listQuery.regionName"
          placeholder="名录名称"
          size="small"
        />
        <el-select
          v-model="listQuery.ifContinuousTracking"
          :options="ifContinuousTrackingList"
          :style="{
            width: '12.5rem',
          }"
          clearable
          size="small"
          placeholder="持续跟踪"
        ></el-select>
        <el-select
          v-model="listQuery.tags"
          :options="tagList"
          :props="{
            value: 'regionFeatureId',
            label: 'name',
          }"
          :style="{
            width: '12.5rem',
          }"
          placeholder="标签"
          filterable
          multiple
          clearable
          size="small"
          collapse-tags
        ></el-select>
        <el-button 
          icon="Search"
          size="small"
          type="primary"
          @click="selectList"
          :loading="listQuery.loading"
        >查询</el-button>
      </div>
    </div>
    <div class="table-body">
      <!-- 原表格保留，注释不移除 -->
      <!-- <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
        :cell-class-name="cellClassName"
      ></TableCom> -->
      <LeafletConstructor
        @mapInit="mapInit"
        :isAddBaseLayer="true"
        :layerControl="true"
      />
      <!-- 图例 -->
      <div class="region-legend">
        <div class="legend-item">
          <span class="legend-color tracking"></span>
          <span>持续跟踪</span>
        </div>
        <div class="legend-item">
          <span class="legend-color not-tracking"></span>
          <span>未跟踪</span>
        </div>
      </div>
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
      />
    </div>
    <AddRegion
      v-if="addRegionTarget"
      :target="addRegionTarget"
      :title="title"
      @close="regionFlagClose"
      @refresh="selectList" />
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, toRaw,
  markRaw, h, defineComponent,
} from 'vue'
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable'
import TableCom from '@/components/TableCom'
import Pagination from '@/components/Pagination'
import ButtonList from '@/components/ButtonList'
import LeafletConstructor from '@/components/LeafletConstructor'
import {
  ElLoading, ElMessageBox, ElImageViewer, ElButton,
} from 'element-plus'
import { queryRegionDirectoryList, deleteRegionDirectory } from '@/api/RegionDirectoryApi';

import AddRegion from './component/addregion';

import { queryRegionFeatureList, } from '@/api/UserWorkspaceDataApi';

// props
const props = defineProps({
  
})
// emit
const emit = defineEmits([
  
])

const addRegionTarget = ref(undefined)
const title = ref('')
const addFun = (target, button, loadFn) => {
  title.value = '新增名录'
  addRegionTarget.value = Object.assign({}, {
    ...target,
  })
  loadFn()
}
const regionFlagClose = () => {
  addRegionTarget.value = undefined;
  title.value = undefined;
}

const searchFun = (target, button, loadFn) => {
  selectList()
  loadFn()
}
const editRegion = (target, button, loadFn) => {
  title.value = '编辑名录'
  addRegionTarget.value = {
    ...target,
  }
  loadFn()
}
const deleteRegion = async(target, button, loadFn) => {
  ElMessageBox.confirm(
    '是否删除该名录？',
    '删除名录',
    {
      confirmButtonText: '删除并关闭',
      cancelButtonText: '取消删除',
      type: 'warning'
    }
  ).then(()=>{
    deleteRegionDirectory({
      id: target.id,
    }).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1)
        selectList()
      }
    })
  }).catch((err) => {
    console.log(err)
  }).finally(()=>{
    loadFn && loadFn()
  })
}

const cellClassName = ({ row, column, rowIndex, columnIndex, })=>{
  // console.log(row, column, rowIndex, columnIndex,);
  if(column['property'] == 'ifContinuousTracking'){
    const className = row['ifContinuousTracking'] == 1?'check-cell':'';
    return `continuous-track-cell ${className}`
  }
}

// 需要序号可添加
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.length + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },
  { label: 'ID', prop: 'id', },
  { label: '区域名称', prop: 'regionName', },
  { label: '区域', prop: 'regionGeom',  icon: "copy" },
  // { label: '目的', prop: 'purpose', },
  { label: '描述', prop: 'regionDesc' },
  { label: '标签', prop: 'tags', 
    fun: (target)=>{
      return (target['tags'] || []).map(e=> e.name ).join()
    }
  },
  { label: '持续跟踪', prop: 'ifContinuousTracking', 
    fun: (target)=>{
      return (target['ifContinuousTracking'] || []) == 1?'是':'否';
    }
  },
  { label: '操作', 
    buttonList: [
      { name: '修改', icon: 'el-Edit', fun: editRegion, type: 'warning' },
      { name: '删除', icon: 'el-Delete', fun: deleteRegion, type: 'danger' },
    ]
  }
])


const buttonTarget = ref({});
const buttonList = ref([
  // { name: '查询', icon: 'el-Search', type: 'primary', fun: searchFun },
  { name: '新增名录', icon: 'el-Plus', type: 'primary', fun: addFun },
])

const tagList = ref([
  
]),
ifContinuousTrackingList = ref([
  { value: 1, label: '是', },
  { value: 0, label: '否', },
])

const tableList = ref([])
let total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20,
      regionName: '',
      tags: [],
      loading: false,
      ifContinuousTracking: undefined,
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  // console.log(listQuery);
  listQuery.loading = true;
  queryRegionDirectoryList({
    ...listQuery,
    pager: listQuery,
    tagName: tagList.value.filter(tag=>{
      return listQuery.tags.includes(tag['regionFeatureId']);
    }).map(tag=> tag['name']).join(),
  }).then(res=>{
    if(res.data.code == 1004){
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount;
      renderRegions(res.data.dataList);
    }
  }).catch(err=>{
    console.log(err)
  }).finally(()=>{
    listQuery.loading = false;
  })
}

// 标签list
const queryRegionFeatureListFn = ()=>{
  queryRegionFeatureList({}).then(res=>{
    if(res.data.code == 1004){
      tagList.value = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

})

// ===== 地图相关 =====
let map, layerGroup;
const mapInit = (mapInstance) => {
  map = toRaw(mapInstance);
  layerGroup = L.featureGroup().addTo(map);
  selectList();
}

const trackingStyle = {
  color: 'rgba(13, 190, 13, 0.3)',
  fillColor: 'rgba(13, 190, 13, 0.3)',
  fillOpacity: 0.4,
  weight: 2,
}
const notTrackingStyle = {
  color: 'rgba(218, 23, 23, 0.3)',
  fillColor: 'rgba(218, 23, 23, 0.3)',
  fillOpacity: 0.4,
  weight: 2,
}

const createPopupComponent = (item, map) => {
  const tags = (item.tags || []).map(e => e.name).join(', ');
  const isTracking = item.ifContinuousTracking == 1;

  return defineComponent({
    setup() {
      const onEdit = () => {
        map.closePopup();
        editRegion(item, null, () => {});
      };
      const onDelete = () => {
        map.closePopup();
        deleteRegion(item, null, () => {});
      };
      return () => {
        const contentArray = [
          h('h4', [
            item.regionName || '',
            h('span', {
              class: `tracking-tag ${isTracking ? 'tracking-tag-yes' : 'tracking-tag-no'}`
            }, isTracking ? '跟踪中' : '未跟踪'),
          ])
        ];
        if (item.regionDesc) {
          contentArray.push(h('p', [ h('b', '描述：'), item.regionDesc ]));
        }
        if (tags) {
          contentArray.push(h('p', [ h('b', '标签：'), tags ]));
        }
        contentArray.push(h('div', { class: 'popup-actions' }, [
          h(ElButton, { size: 'small', type: 'warning', onClick: onEdit }, () => '修改'),
          h(ElButton, { size: 'small', type: 'danger', onClick: onDelete }, () => '删除'),
        ]));

        return h('div', { class: 'region-popup-content' }, contentArray);
      };
    }
  });
};

const renderRegions = (list) => {
  if (!layerGroup) return;
  layerGroup.clearLayers();
  list.forEach(item => {
    if (!item.regionGeom) return;
    try {
      const geom = JSON.parse(item.regionGeom);
      const style = item.ifContinuousTracking == 1 ? trackingStyle : notTrackingStyle;
      let targetLayer;
      L.geoJSON(geom, {
        style: () => style,
        onEachFeature: (feature, layer) => {
          targetLayer = layer;
        }
      });
      if (!targetLayer) return;

      // 由于全局 leaflet.js 拦截了 onEachFeature 并重写了颜色，这里必须再强行设置一次才能生效
      targetLayer.setStyle(style);

      // tooltip 显示名称（sticky 跟随鼠标，top 避免遮挡）
      targetLayer.bindTooltip(item.regionName || '', {
        permanent: false, direction: 'top',
        sticky: true,
        offset: [0, 0],
        className: 'leaflet-tooltip-message',
      });

      // 点击 → popup 显示详情 + 操作按钮（使用 Vue 组件 - 原生 bindPopup 延迟挂载）
      const app = vueCreateAppInit(createPopupComponent(item, map), {});

      const onPopupOpen = (() => {
        let isMounted = false;
        return (event) => {
          if (!isMounted) {
            const popupEl = event.popup.getElement();
            const contentDom = popupEl.querySelector('.leaflet-popup-content');
            if (contentDom) {
              app.mount(contentDom);
              isMounted = true;
            }
          }
        };
      })();

      targetLayer.bindPopup('<div class="region-popup-mount-point"></div>', {
        className: 'region-directory-popup',
        maxWidth: 300,
        minWidth: 180,
        closeButton: false,
      }).on({
        popupopen: onPopupOpen,
        remove: () => app.unmount()
      });

      targetLayer.addTo(layerGroup);
    } catch (e) {
      console.error('renderRegion error:', e);
    }
  });

  // 触发全局多边形大小面积重排洗牌，解决重叠遮挡问题
  if (map && map.organizePolygonsByArea) {
    map.organizePolygonsByArea();
  }

  // 自动定位
  nextTick(() => {
    const bounds = layerGroup.getBounds();
    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [30, 30] });
    }
  });
}

// 组件挂载后
onMounted(()=>{
  queryRegionFeatureListFn();
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{
})

</script>

<style lang='less'>
.continuous-track-cell{
  color: rgb(255, 255, 255);
  .content-div{
    width: max-content !important;
    border-radius: 5px;
    background-color: rgb(218, 23, 23);
    padding: 0 10px;
    margin: 0 auto;
  }
}
.continuous-track-cell.check-cell{
  .content-div{
    background-color: rgb(13, 190, 13);
  }
}
</style>

<style lang='less' scoped>
.user-manage-constructor {
  padding: 10px;
  --h3Height: 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  .table-body {
    flex: 1;
    min-height: 0;
    position: relative;
  }

  .region-legend {
    position: absolute;
    bottom: 30px;
    right: 10px;
    background: var(--domBackgroundColor);
    border-radius: var(--borderRadiusSize);
    padding: 8px 12px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);

    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: var(--fontColor_24);
    }
    .legend-color {
      width: 12px;
      height: 12px;
      border-radius: 2px;
      &.tracking { background: rgb(13, 190, 13); }
      &.not-tracking { background: rgb(218, 23, 23); }
    }
  }
}
</style>

<style lang='less'>
</style>
